import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  tunjanganLainService = {}

tunjanganLainService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/tunjangan_lain/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tunjanganLainService.show = function (token,data='') {
    return fetch({
        url: '/transaksi/tunjangan_lain/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tunjanganLainService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/tunjangan_lain/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

tunjanganLainService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/tunjangan_lain/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

tunjanganLainService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/tunjangan_lain/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default tunjanganLainService;
